import { render, staticRenderFns } from "./UserBulkUpload.vue?vue&type=template&id=0f72e407&scoped=true"
import script from "./UserBulkUpload.vue?vue&type=script&lang=js"
export * from "./UserBulkUpload.vue?vue&type=script&lang=js"
import style0 from "./UserBulkUpload.vue?vue&type=style&index=0&id=0f72e407&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f72e407",
  null
  
)

export default component.exports